<template>
  <div
    v-show="isShow"
    class="tw-fixed tw-top-[56px] tw-w-full tw-h-screen tw-z-[9998] tw-left-0 tw-bg-[rgba(0,0,0,0.5)]"
    @click.stop="$emit('close-menu')"
  />
  <div v-show="isShow" class="global-search-menu">
    <MenuTopic
      :selected-filter-ids="selectedFilterIds"
      :search-key="searchKey"
      :searching="searching"
      @close-menu="$emit('close-menu')"
      @on-select="updateSearchKey"
    />
    <MenuFilter
      :selected-filter-ids="selectedFilterIds"
      @on-select="selectedFilterIds = $event"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { TopicName } from "@/components/common/globalSearch/constants";

/** components */
import MenuFilter from "@/components/common/globalSearch/menuSearch/menuFilter.vue";
import MenuTopic from "@/components/common/globalSearch/menuSearch/menuTopic.vue";

const props = defineProps<{
  isShow: boolean;
  searchKey: string;
  searching: number;
}>();

const emit = defineEmits<{
  (e: "close-menu"): void;
  (e: "update-search-key", value: string[]): void;
}>();

const updateSearchKey = (value: any) => {
  emit("update-search-key", value);
};

const selectedFilterIds = ref([TopicName.all]);
</script>

<style lang="scss" scoped>
.global-search-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 7px;
  z-index: 9999;
  display: flex;
  flex-direction: row;
  overflow-y: auto;
  min-width: 280px;
  margin-top: 20px;
}
</style>
